import { Tag } from "@chakra-ui/react";

interface TagStatusProps {
  color: string;
  status: string;
  bg?: string;
}

function TagStatus({ color, status, bg = "white" }: TagStatusProps) {
  return (
    <Tag
      alignSelf="end"
      bg={bg}
      borderRadius={14}
      border={`solid 1px`}
      color={color}
      fontWeight={400}
      pt={1}
      pb={1}
      px={4}
      w="fit-content"
      noOfLines={1}
    >
      {status}
    </Tag>
  );
}

export default TagStatus;
